<template>
    <pop-form v-if="show" width="990px" body-max-height="547px">
        <template v-slot:title>
            {{title}}
            <span class="close" @click="close">
                <i class="el-icon-close"></i>
            </span>
        </template>
        <div class="history-box">
            <div class="head-box tc">
                <el-row>
                    <el-col :span="6">
                        <div class="label">总积分</div>
                        <div class="value">{{countInfo.all_score ? countInfo.all_score : 0}}</div>
                    </el-col>
                    <el-col :span="6">
                        <div class="label">可用积分</div>
                        <div class="value">{{countInfo.sur_score ? countInfo.sur_score : 0}}</div>
                    </el-col>
                    <el-col :span="6">
                        <div class="label">已消耗积分</div>
                        <div class="value">{{countInfo.used_score ? countInfo.used_score : 0}}</div>
                    </el-col>
                    <el-col :span="6">
                        <div class="label">已过期积分</div>
                        <div class="value">{{countInfo.expire_score ? countInfo.expire_score : 0}}</div>
                    </el-col>
                </el-row>
            </div>
            <div class="list-box">
                <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil" width="100%" height="370px"
                          header-cell-class-name="table-ceil"
                >
                    <el-table-column label="时间" prop="create_datetime" width="200" />
                    <el-table-column label="姓名" prop="name" />
                    <el-table-column label="描述" prop="desc" width="250" />
                    <el-table-column label="积分变化" prop="change" />
                    <el-table-column label="消费前积分" prop="before" />
                    <el-table-column label="消费后积分" prop="after" />
                </el-table>
            </div>
        </div>
        <template v-slot:foot>
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper, slot"
                        :total="page.count">
                </el-pagination>
            </div>
        </template>
    </pop-form>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    import ScoreHistoryList from "@/model/Score/ScoreHistoryList";
    export default {
        name: "StoreUserScoreHistory",
        components: {ScoreHistoryList, PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: [String, Number],
                default: 0
            }
        },
        data: () => ({
            title: "积分记录",
            tableData: [],
            countInfo: {},
            //分页
            page: {
                nowPage: 1,
                pageSize: 20,
                pageSizes: [20, 50, 100],
                count: 0,
            },
        }),
        mounted: function () {

        },
        methods: {
            init: function () {
                this.tableData = [];
                this.countInfo = {};
                this.page = {
                    nowPage: 1,
                    pageSize: 20,
                    pageSizes: [20, 50, 100],
                    count: 0,
                };
            },
            //关闭
            close: function () {
                this.$emit("showChange", false);
            },
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            },
            pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            },
            //加载列表数据
            loadListData: function () {
                this.init();
                let postData = {
                    store_uid: this.storeUid ? this.storeUid : 0,
                    page: this.page.nowPage,
                    num: this.page.pageSize,
                };
                obj.postData("score/get_score_history", postData, res => {
                    if(res.errcode === 0){
                        this.countInfo = res.data.count_info;
                        this.tableData = res.data.list_data;
                        this.page.count = res.data.count;
                    }else{
                        this.tableData = [];
                    }
                });
            }
        },
        watch: {
            show: function (v) {
                if(v) this.loadListData();
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
        line-height: 24px;
        cursor: pointer;
    }
    .history-box{
        height: 500px;
        padding: 0px 10px;
        display: flex;
        flex-flow: column nowrap;
    }
    .head-box{
        background-color: #f7f8fa;
        padding: 30px 0px;
    }
    .head-box .label{
        color: #333333;
    }
    .head-box .value{
        font-weight: bold;
        font-size: 20px;
        color: #333333;
    }
    .list-box{
        margin-top: 20px;
        flex: 1;
    }
</style>
